import { ReactNode } from 'react';
import { PanelProps } from '../Panel';
import { TooltipHeader } from './TooltipHeader';

export function getHeader(props: PanelProps): ReactNode | string {
    if (props.tooltip) {
        return TooltipHeader(props);
    }

    return props.header;
}
